<div class="graph-container" *ngIf="data && data.length > 0; else noData">
  <ngx-charts-polar-chart [labelTrim]="false" [autoScale]="true" [animations]="true" [xAxis]="true" [yAxis]="true"
    [legend]="showLegend" [results]="data"></ngx-charts-polar-chart>
</div>
<ng-template #noData>
  <h3 *ngIf="noDataMessage">{{noDataMessage}}</h3>
</ng-template>